import Base from "../base.store";
import lodash from "lodash";
import moment from "moment";
import { cacheTime } from "../../../../utils/constant";
import { filter } from "../../../../utils/search";

const baseUrl = "/api/v1/master/departments";
const base = new Base(baseUrl);

export default {
    namespaced: true,
    state: lodash.merge(lodash.cloneDeep(base.state), {
        listWithChildren: [],
        listWithChildrenType: {},
        cacheDate: {
            listWithChildren: null,
            listWithChildrenType: {}
        }
    }),
    getters: {
        ...base.getters
    },
    actions: {
        ...base.actions,
        cacheFindAll(context, { where, sort, options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.list;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            if(!sort) {
                sort = [{ name: "nameTh", type: "ASC" }];
            }
            const list = context.state.list || [];
            if (list?.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAll", { criteria: { select: ["*", "refDepartmentType.*"] } }).then(list => filter({ list, where, sort }));
        },
        cacheFindAllWithChildren(context, { options }) {
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listWithChildren;
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const list = context.state.listWithChildren || [];
            if (list?.length > 0 && !force) {
                return list;
            }
            return context.dispatch("findAllWithChildren", {});
        },
        findAllWithChildren(context, { criteria, config }) {
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "refParent.id", type: "UUID", operator: "=", value: null }
                    ],
                    sort: [{ name: "nameTh", type: "ASC" }],
                    children: [{ name: "children", select: ["*"], page: 0, size: 1000000, isRecursive: true }]
                },
                criteria
            );
            return context.dispatch("search", { criteria, config }).then(page => {
                const list = page.data;
                context.commit("setListWithChildren", { list });
                return list;
            });
        },
        cacheFindAllWithChildrenType(context, { options, type, isRegister, isDocument, isImport, isExport, where = [], nameTh }) {
            const key = type + isRegister + isDocument + isImport + isExport;
            let force = options?.force ? options.force : false;
            const cacheDateResult = context.state.cacheDate.listWithChildrenType[key];
            if (cacheDateResult && cacheDateResult.isBefore(moment())) {
                force = true;
            }
            const list = context.state.listWithChildrenType[key] || [];
            const sort = [{ name: "nameTh", type: "asc" }];
            if (nameTh) {
                where.push({ name: "nameTh", operator: "like", value: nameTh });
            }
            if (list.length > 0 && !force) {
                return filter({ list, where, sort });
            }
            return context.dispatch("findAllWithChildrenType", { type, isRegister, isDocument, isImport, isExport })
                .then((list) => filter({ list, where, sort }));
        },
        findAllWithChildrenType(context, { criteria, config, type, isRegister, isDocument, isImport, isExport }) {
            const key = type + isRegister + isDocument + isImport + isExport;
            criteria = lodash.merge(
                {
                    select: ["**"],
                    page: 0,
                    size: 1000000,
                    where: [
                        { name: "isActive", type: "Boolean", operator: "=", value: true },
                        { name: "refParent.id", type: "UUID", operator: "=", value: null },
                        { name: "refDepartmentType.key", type: "String", operator: "=", value: type }
                    ],
                    sort: [{ name: "nameTh", type: "ASC" }],
                    children: [{ name: "children", select: ["*"], page: 0, size: 1000000, where: [], isRecursive: true }]
                },
                criteria
            );
            if (isRegister !== undefined) {
                criteria.where.push({ name: "isRegister", type: "Boolean", operator: "=", value: isRegister });
                criteria.children?.[0].where.push({ name: "isRegister", type: "Boolean", operator: "=", value: isRegister });
            }
            if (isDocument !== undefined) {
                criteria.where.push({ name: "isDocument", type: "Boolean", operator: "=", value: isDocument });
                criteria.children?.[0].where.push({ name: "isDocument", type: "Boolean", operator: "=", value: isDocument });
            }
            if (isImport !== undefined) {
                criteria.where.push({ name: "isImport", type: "Boolean", operator: "=", value: isImport });
                criteria.children?.[0].where.push({ name: "isImport", type: "Boolean", operator: "=", value: isImport });
            }
            if (isExport !== undefined) {
                criteria.where.push({ name: "isExport", type: "Boolean", operator: "=", value: isExport });
                criteria.children?.[0].where.push({ name: "isExport", type: "Boolean", operator: "=", value: isExport });
            }
            return context.dispatch("search", { criteria, config }).then(page => {
                const list = page.data;
                context.commit("setListWithChildrenType", { list, key });
                return list;
            });
        }
    },
    mutations: {
        ...base.mutations,
        setListWithChildren(state, { list }) {
            state.listWithChildren = list;
            state.cacheDate.listWithChildren = moment().add(cacheTime, "ms");
        },
        setListWithChildrenType(state, { list, key }) {
            state.listWithChildrenType[key] = list;
            state.cacheDate.listWithChildrenType[key] = moment().add(cacheTime, "ms");
        }
    }
};
